module.exports = __webpack_public_path__ + "img/tutoriales_para_preparar_mezcla brava.f71ba20b.png";